import analytics from '../../../RSLQLD/source/modules/analytics/analytics';

if($('.accordion-item-header').length) {
  $('.accordion-item-header').on('click', function () {
    const accordionToggle = $(this);
    const wrapperElement = accordionToggle.closest('.accordion-item');
    const revealElement = accordionToggle.siblings('.accordion-item-body');
    const isOpen = wrapperElement.hasClass('accordion-open');
    const title = wrapperElement.find(".accordion-item-header").text().replace(/^\s+|\s+$/g, '');
    wrapperElement.data("ga-config", "eventName=trackButtonClick&buttonGroup=Accordion&buttonCallToAction=&buttonDescription="+title+"&buttonPlacement=&action="+window.location.pathname+"&buttonDestination=" + (isOpen ? "close accordion" : "open accordion"));
    analytics.trackDataLayerBtnEvent(wrapperElement);
    if (isOpen) {
      wrapperElement.removeClass('accordion-open');
      revealElement.css('height', '0px');
    } else {
      wrapperElement.addClass('accordion-open');
      // calculate the size of child elements and set the div height through javascript
      // if we could use CSS3 animations between height: 0 and height: auto we wouldn't need this, but that doesn't work.  The animation itself here is still CSS driven so it's hardware accelerated and nice and smooth.
      let totalHeight = 0;
      revealElement.children().each(function () {
        totalHeight += $(this).outerHeight();
      });
      revealElement.css('height', totalHeight);
    }
  });
  // check for open accordions that may need to be resized
  $(window).smartresize(() => {
    // chillaxed resize events
    $('.accordion-open .accordion-item-body').each(function () {
      const revealElement = $(this);
      let totalHeight = 0;
      revealElement.children().each(function () {
        totalHeight += $(this).outerHeight();
      });
      revealElement.css('height', totalHeight);
    });
  });
}
